// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1J_2o","col":"Table_col__1IccO","fulfillmentStatus":"Table_fulfillmentStatus__1Oenb","emailCol":"Table_emailCol__3rmBz"};